<template>
    <div class="list-wrapper">
        <talk-list :focus="true" ref="talkList"></talk-list>     
    </div>
</template>

<script>
    import TalkList from './List';

    export default {
        name: 'TalkFllow',

        components: {TalkList},

        beforeRouteEnter(to, from, next) { 
            next(vm => {
                if( from.path === "/community/circle/all" || from.path === "/wxapp/circle/all") {
                    vm.$refs.talkList.onRefresh()
                }
            })
        },

        beforeRouteLeave(to, from, next) {
            if(this.$route.matched.some(item => item.path === to.path)) return
            next()
        }    
    }
</script>

<style scoped lang="less">
</style>